const css = `.Uc0BMW__menu{width:300px;height:400px;border-right:2px solid var(--base-strokes-default);box-shadow:0 1px 3px #0000001a}.Uc0BMW__definition{width:500px;height:400px;position:relative}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"menu":"Uc0BMW__menu","definition":"Uc0BMW__definition"};
